export const getPointOfInterestSubnav = (projectId: string, pointOfInterestId: string, moodId: string) => [
  {
    title: 'Point of Interest Details',
    to: `/project/${projectId}/mood/${moodId}/point-of-interest/${pointOfInterestId}`
  },
  {
    title: 'Translations',
    to: `/project/${projectId}/mood/${moodId}/point-of-interest/${pointOfInterestId}/translations`
  },
]
